export const commonsamples_German = [
   
   
   
    {
        id:0,
        chatname:"Grammatik überprüfen",
        promptsandresponses:[
            {
             id:1,
             prompt:"Ich war dort.",
             response:"Ich war dort."
            },
        ]
    },
    {
        id:1,
        chatname:"Schlüsselwörter extrahieren",
        promptsandresponses:[
            {
             id:1,
             prompt:"Elektroautos gibt es schon seit einiger Zeit, aber erst in den letzten Jahren sind sie beliebter geworden. Mit der zunehmenden Sorge um die Umwelt und die globale Erwärmung erwägen viele Menschen nun Elektroautos als Alternative zu herkömmlichen benzinbetriebenen Autos. Einer der Hauptvorteile von Elektroautos ist, dass sie keine Emissionen produzieren. Das bedeutet, dass sie keine schädlichen Gase in die Atmosphäre abgeben, was eine gute Nachricht für unseren Planeten ist. Außerdem sind sie viel leiser als herkömmliche Autos und daher eine gute Wahl für Fahrten in der Stadt.",

             response:"Elektroautos, Umwelt, globale Erwärmung, Alternative, benzinbetriebene Autos, keine Emissionen, schädliche Gase, Atmosphäre, Planet, leiser, Fahrten in der Stadt."
            },
        ]
    },
    {
        id:2,
        chatname:"Zusammenfassung",
        promptsandresponses:[
            {
             id:1,
             prompt:"Elektroautos gibt es schon seit einiger Zeit, aber erst in den letzten Jahren sind sie beliebter geworden. Mit der zunehmenden Sorge um die Umwelt und die globale Erwärmung erwägen viele Menschen nun Elektroautos als Alternative zu herkömmlichen benzinbetriebenen Autos. Einer der Hauptvorteile von Elektroautos ist, dass sie keine Emissionen produzieren. Das bedeutet, dass sie keine schädlichen Gase in die Atmosphäre abgeben, was eine gute Nachricht für unseren Planeten ist. Außerdem sind sie viel leiser als herkömmliche Autos und daher eine gute Wahl für Fahrten in der Stadt.",

             response:"Elektroautos gewinnen aufgrund der wachsenden Sorge um die Umwelt und die globale Erwärmung an Beliebtheit. Sie produzieren keine Emissionen und sind viel leiser als herkömmliche Autos, was sie zu einer großartigen Option für Fahrten in der Stadt macht."
            },
        ]
    },
    {
        id:3,
        chatname:"Kompakt",
        promptsandresponses:[
            {
             id:1,
             prompt:"Elektroautos gibt es schon seit einiger Zeit, aber erst in den letzten Jahren sind sie beliebter geworden. Mit der zunehmenden Sorge um die Umwelt und die globale Erwärmung erwägen viele Menschen nun Elektroautos als Alternative zu herkömmlichen benzinbetriebenen Autos. Einer der Hauptvorteile von Elektroautos ist, dass sie keine Emissionen produzieren. Das bedeutet, dass sie keine schädlichen Gase in die Atmosphäre abgeben, was eine gute Nachricht für unseren Planeten ist. Außerdem sind sie viel leiser als herkömmliche Autos und daher eine gute Wahl für Fahrten in der Stadt.",

             response:"Elektroautos sind aufgrund von Umweltbedenken beliebter geworden. Sie produzieren keine Emissionen, was sie zu einer guten Wahl für Fahrten in der Stadt macht."
            },
        ]
    },
    {
        id:4,
        chatname:"Beschreibung",
        promptsandresponses:[
            {
             id:1,
             prompt:"Ledertasche, braun, unter 29 $",

             response:`Die Ledertasche ist ein stilvolles und funktionales Accessoire, das perfekt für jede Gelegenheit ist. Hergestellt aus hochwertigem braunem Leder, ist diese Tasche strapazierfähig und langlebig. Sie verfügt über ein geräumiges Hauptfach, in dem Sie all Ihre Essentials wie Telefon, Geldbörse, Schlüssel und mehr aufbewahren können. Die Tasche hat ein einfaches, aber elegantes Design mit einem einzigen Schultergurt, der das Tragen erleichtert. Sie ist leicht und bequem, und der verstellbare Gurt sorgt für eine perfekte Passform für jeden Körpertyp.
             Am besten ist, dass diese Ledertasche für unter 29 $ erhältlich ist und somit eine erschwingliche Option für alle ist, die eine hochwertige Tasche möchten, ohne dabei die Bank zu sprengen. Egal, ob Sie Besorgungen machen, zur Arbeit gehen oder ausgehen, diese Ledertasche ist das perfekte Accessoire, um Ihren Look zu vervollständigen.`
            },
        ]
    },
    {
        id:5,
        chatname:"E-Mail",
        promptsandresponses:[
            {
             id:1,
             prompt:"Eltern-Lehrer-Konferenz, 12:30 Uhr, Mittwoch, Absender: Tom",

             response:`Betreff: Erinnerung - Eltern-Lehrer-Konferenz, 12:30 Uhr, Mittwoch
             \n\nLiebe Eltern,\n\nIch hoffe, diese E-Mail erreicht Sie wohlauf. Nur eine kurze Erinnerung, dass wir die Eltern-Lehrer-Konferenz für 12:30 Uhr am Mittwoch geplant haben. Diese Konferenz ist eine großartige Gelegenheit, um über den Fortschritt Ihres Kindes in der Schule zu sprechen und etwaige Bedenken oder Fragen zu besprechen.\
             \nWie Sie alle wissen, wird die Konferenz dieses Jahr online stattfinden, und Sie erhalten einen Link, um an der Konferenz per E-Mail teilzunehmen. Bitte stellen Sie sicher, dass Sie vor Beginn der Konferenz Ihre E-Mails überprüfen. Bei technischen Schwierigkeiten zögern Sie bitte nicht, mich zu kontaktieren, und ich werde Ihnen gerne behilflich sein. Ich freue mich darauf, Sie alle zu treffen und den Fortschritt Ihres Kindes in der Schule zu besprechen. Wir haben viel zu besprechen, also kommen Sie bitte vorbereitet mit Fragen oder Anliegen, die Sie haben mögen.
             \n\nVielen Dank, und ich werde Sie alle am Mittwoch sehen.
             \n\nMit freundlichen Grüßen,
             \n\nTom
             `
            },
        ]
    },
    {
        id:6,
        chatname:"Geschichte",
        promptsandresponses:[
            {
             id:1,
             prompt:"ein Vogel, ein Hund, sonniger Tag",

             response:`Es war einmal an einem sonnigen Tag, ein Vogel saß auf einem Ast und sang eine melodische Melodie. Der Vogel genoss die warme Sonne und die frische Luft. Plötzlich kam ein Hund bellend auf den Baum zugerannt. Der Vogel erschrak und flog weg, aber der Hund verfolgte ihn weiter.\nDer Vogel flog so schnell er konnte, aber der Hund war schnell und entschlossen. Während der Verfolgung bemerkte der Vogel, dass der Hund ihm nichts antun wollte, sondern nur spielen wollte. Der Vogel landete auf einem nahegelegenen Ast, immer noch ängstlich, aber neugierig. Der Hund versuchte den Baum hinaufzuklettern, aber er war zu hoch für ihn.\nDer Vogel erkannte, dass der Hund keine Bedrohung darstellte und beschloss, mitzuspielen. Er fing an zu zwitschern und umherzufliegen und lud den Hund zum Spielen ein. Der Hund war begeistert und wedelte glücklich mit dem Schwanz. Die beiden begannen, sich um den Baum herum zu jagen und hatten die Zeit ihres Lebens.
             Als der Tag verging, begann die Sonne zu untergehen, und der Vogel wusste, dass es Zeit war zu gehen. Er zwitscherte dem Hund zum Abschied zu und flog davon. Der Hund beobachtete, wie er am Horizont verschwand, fühlte sich ein wenig traurig, aber auch glücklich über den Spaß, den sie geteilt hatten.
             Von diesem Tag an kam der Hund oft zu dem Baum in der Hoffnung, den Vogel wiederzusehen. Obwohl sie nie wieder miteinander spielten, blieb die Erinnerung an diesen sonnigen Tag für immer in des Hundes Herzen. Es war eine Erinnerung an die Freude, die aus unerwarteten Freundschaften entsteht, und an die Schönheit der Natur an einem sonnigen Tag.`
            },
        ]
    },
   
    {
        id:7,
        chatname:"Verbessern",
        promptsandresponses:[
            {
             id:1,
             prompt:"Elektroautos gewinnen aufgrund der wachsenden Sorge um die Umwelt und den Klimawandel an Beliebtheit. Sie produzieren keine Emissionen und sind viel leiser als herkömmliche Autos, was sie zu einer großartigen Option für das Fahren in der Stadt macht.",

             response:"Elektrofahrzeuge werden aufgrund wachsender Bedenken hinsichtlich der Umwelt und des Klimawandels immer beliebter. Diese Fahrzeuge produzieren keine Emissionen und arbeiten leiser als herkömmliche Autos, was sie zu einer idealen Wahl für das Fahren in der Stadt macht."
            },
        ]
    }

    

]
